import {
  ActivityFragment,
  SelectedActivityFragment,
} from '@/graphql/custom-types';
import {
  ActivityCancelSignupScreenDocument,
  ActivitySignupScreenDocument,
  ActivitySubscription,
  GetActivitiesByFiltersDocument,
  GetActivityEntryDocument,
  ScreenProfile,
} from '@/graphql/generated-types';
import { apolloClient } from '@/utils/apollo';
import SentryGraphQLError from '@/utils/exceptions/SentryGraphQLError';

const signup = async (
  profile: ScreenProfile,
  subscription: ActivitySubscription
) => {
  const response = await apolloClient.mutate({
    mutation: ActivitySignupScreenDocument,
    variables: {
      profile,
      subscription,
    },
    errorPolicy: 'all',
  });

  if (response.data?.activitySignupScreen?.success) {
    return response.data;
  }

  throw new SentryGraphQLError(`api.activities.signup`, response);
};

const cancelSignup = async (
  profile: ScreenProfile,
  subscription: ActivitySubscription
) => {
  const response = await apolloClient.mutate({
    mutation: ActivityCancelSignupScreenDocument,
    variables: {
      profile,
      subscription,
    },
    errorPolicy: 'all',
  });

  if (response.data?.activityCancelSignupScreen?.success) {
    return response.data;
  }

  throw new SentryGraphQLError(`api.activities.cancelSignup`, response);
};

const getActivityEntry = async (
  id: string
): Promise<SelectedActivityFragment> => {
  const response = await apolloClient.query({
    query: GetActivityEntryDocument,
    variables: {
      ids: [id],
    },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  if (
    response.data?.activity?.getActivities &&
    response.data.activity.getActivities.length > 0
  ) {
    const [item] = response.data.activity.getActivities;
    return item;
  }

  throw new SentryGraphQLError(`api.activities.getActivityEntry`, response);
};

const getActivityRange = async (
  departmentId: string,
  dateFrom: string,
  dateTo: string
): Promise<ActivityFragment[]> => {
  const response = await apolloClient.query({
    query: GetActivitiesByFiltersDocument,
    variables: {
      filter: {
        departments: [departmentId],
      },
      dateFrom,
      dateTo,
    },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  if (response.data?.activity?.getActivitiesByFilters) {
    return response.data.activity.getActivitiesByFilters;
  }

  throw new SentryGraphQLError(`api.activities.getActivityRange`, response);
};

export default {
  signup,
  cancelSignup,
  getActivityEntry,
  getActivityRange,
};
